import { type DeepMap, type FieldError } from 'react-hook-form';

export const getComponentFormError = (
  name: string,
  errors: DeepMap<Record<string, any>, FieldError>
): FieldError | undefined => {
  const errorBase = errors[name];
  if (errorBase) {
    return errorBase;
  }

  const { indexOpenBracket, indexCloseBracket, indexPoint } = {
    indexOpenBracket: name.indexOf('['),
    indexCloseBracket: name.indexOf(']'),
    indexPoint: name.indexOf('.')
  };

  if (indexOpenBracket === -1 || indexCloseBracket === -1 || indexPoint === -1) {
    return undefined;
  }

  const index = name.substring(indexOpenBracket + 1, indexCloseBracket);

  if (Number.isNaN(index)) {
    return undefined;
  }

  const arrErrors = errors[name.substring(0, indexOpenBracket)] as Array<
    DeepMap<Record<string, any>, FieldError>
  >;

  if (!arrErrors) {
    return undefined;
  }

  const indexNumber = parseInt(index, 10);
  const indexError = Array.prototype.hasOwnProperty.call(
    arrErrors as Array<DeepMap<Record<string, any>, FieldError>>,
    indexNumber
  )
    ? arrErrors[indexNumber]
    : undefined;

  return indexError ? indexError[name.substring(indexPoint + 1, name.length)] : indexError;
};
